<template>
  <div class="services__entry" id="services__entry">
    <img class="home__entry--background" src="https://notaireleveillee.s3.ca-central-1.amazonaws.com/img/services.jpg" alt="Notaire outremont">
    <div class="services__entry--content">
      <h1 class="services__entry--content--title">{{ $t("servicesTranslate.servicesEntryTitle") }}</h1>
    </div>
    <div class="services__entry--anchor-list">
      <a v-on:click="clickfuncService1()">{{ $t("servicesTranslate.servicesEntryAnchorToService1") }}</a>
      <a v-on:click="clickfuncService2()">{{ $t("servicesTranslate.servicesEntryAnchorToService2") }}</a>
      <a v-on:click="clickfuncService3()">{{ $t("servicesTranslate.servicesEntryAnchorToService3") }}</a>
      <a v-on:click="clickfuncService4()">{{ $t("servicesTranslate.servicesEntryAnchorToService4") }}</a>
      <a v-on:click="clickfuncService5()">{{ $t("servicesTranslate.servicesEntryAnchorToService5") }}</a>
      <a v-on:click="clickfuncService6()">{{ $t("servicesTranslate.servicesEntryAnchorToService6") }}</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'services-entry',
  data() {
    return {
      locale: 'fr'
    }
  },
  methods :{
    clickfuncService1() {
      this.$SmoothScroll(document.getElementById('services__variant--1'));
    },
    clickfuncService2() {
      this.$SmoothScroll(document.getElementById('services__variant--2'));
    },
    clickfuncService3() {
      this.$SmoothScroll(document.getElementById('services__variant--3'));
    },
    clickfuncService4() {
      this.$SmoothScroll(document.getElementById('services__variant--4'));
    },
    clickfuncService5() {
      this.$SmoothScroll(document.getElementById('services__variant--5'));
    },
    clickfuncService6() {
      this.$SmoothScroll(document.getElementById('services__variant--6'));
    }
  },
  watch: {
    locale (val) {
      this.$i18n.locale = val
    }
  }
}
</script>
